import { defineStore } from "pinia";
import { instance } from ".";

export const store = defineStore("imageCache", {
  state: () => ({
    cache: JSON.parse(localStorage.getItem("imageCache") || "{}") as Record<
      string,
      string
    >,
  }),
  actions: {
    setImage(path: string, data: string) {
      this.cache[path] = data;
      localStorage.setItem("imageCache", JSON.stringify(this.cache));
    },
    getImage(path: string) {
      return this.cache[path] || null;
    },
  },
});

export const useImageCacheStore = store(instance);
